import { TagKind, TagSaveModel } from "client/Api/Tags/tags";
import { TagSelect } from "client/Components";
import { useSuggestedTagsDataSource } from "client/Features/Tags/useSuggestedTagsDataSource";
import { IValueInputAttachable } from "client/Forms/attachable";
import { AttachTagSelectOptions } from "client/Forms/attachableProps/tagSelect";
import { AlertManager, useAlerts } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useMemo, useState } from "react";

export type AppTagSelectProps = {
	attachable: IValueInputAttachable<readonly TagSaveModel[]>;
};

export const AppTagSelect = (props: AppTagSelectProps): ReactElement => {
	const {
		attachable
	} = props;

	const [searchTerm, setSearchTerm] = useState<string>("");
	const [shouldLoadTags, setShouldLoadTags] = useState<boolean>(false);

	const alertManager: AlertManager = useAlerts();

	const tagSelectOptions = useMemo(
		(): AttachTagSelectOptions => ({
			maxTagCount: 5,
			maxTagLength: 30,
			onError: (message: string): void => {
				alertManager.showError(message);
			}
		}),
		[alertManager]
	);

	const {
		currentItems: suggestedTags,
		getLoadingState
	} = useSuggestedTagsDataSource({
		filtering: {
			selectedTagIds: attachable
				.value
				.map(x => x.id),
			count: 20,
			kind: TagKind.App,
			shouldLoadData: shouldLoadTags
		},
		searchTerm: searchTerm
	});

	return (
		<TagSelect
			{...attachable.attachToTagSelect(tagSelectOptions)}
			onSearch={setSearchTerm}
			searchDebounceInterval={250}
			suggestedTags={suggestedTags}
			placeholder={localize("_AddTag")}
			isBusy={getLoadingState() === "loading"}
			onIsSuggestionsBoxOpenChange={setShouldLoadTags}
			menuTitle={localize("_Tags")}
		/>
	);
};
AppTagSelect.displayName = "AppTagSelect";